<template>
<v-container fill-height justify-center align-center >
  <!-- <v-layout row > -->
    <v-flex xs12 sm10 lg5 md8>
      <v-card class="mt-0 pt-0">
          <v-card-title class="primary">
            <h4 style="color:white">TAP-SIGNUP</h4>
          </v-card-title>
          <v-card-text>
              <v-form ref="signupForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 md3>
                      <v-select
                        :items="items"
                        v-model="user.gender"
                        label="Title"
                        box
                        required
                        :rules="rules.isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex  xs12 md5>
                      <v-text-field box name="firstName" v-model="user.firstName" label="First Name" :rules="rules.isRequired" required value="Input text"></v-text-field>
                    </v-flex>
                    <v-flex  xs12 md4>
                      <v-text-field box name="lastName" v-model="user.lastName" :rules="rules.isRequired" required label="Last Name"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex  xs12>
                      <v-text-field box name="email" type="email" v-model="user.email" label="Email" :rules="rules.email" required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex  xs3>
                      <v-text-field value="+91" readonly box label="Mobile"></v-text-field>
                    </v-flex>
                    <v-flex  xs9>
                      <v-text-field box name="mobile" v-model="user.phone" :rules="rules.isRequired" mask="##########" required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex  xs12>
                      <v-text-field box name="password" type="password" v-model="user.password" label="Password" :rules="rules.isRequired" required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex  xs12>
                      <v-text-field box type="password" v-model="confirmPassword" label="Confirm Password" :rules="rules.isRequired" required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <div v-show="confirmPassword.length>0">
                    <span v-if="user.password === confirmPassword" class="green--text">Password Match</span>
                    <span v-else class="red--text">Password doesn't match</span>
                  </div>
                </v-container>
              </v-form>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" to="/" round outline>Login</v-btn>
                <v-btn color="primary" @click.native="signup" round>SIGNUP</v-btn>
              </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  <!-- </v-layout> -->
  </v-container>
</template>
<script>
/* globals Store */

import { User } from '@/models'
export default {
  data () {
    return {
      user: new User(),
      confirmPassword: '',
      items: [
        {
          text: 'Mr.',
          value: 'mr'
        },
        {
          text: 'Mrs.',
          value: 'mrs'
        },
        {
          text: 'Ms.',
          value: 'ms'
        },
        {
          text: 'Mx.',
          value: 'mx'
        }
      ],
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        email: [
          (v) => !!v || 'Required',
          (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
        ]
      }
    }
  },
  methods: {
    signup () {
      if (this.$refs.signupForm.validate()) {
        Store.dispatch('user/signup', this.user)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue